//
//
//
//
//
//
//
//
//
//
//
//
//
//

import createHead from './headList.js';
import viewportMixin from '@/mixins/viewport.mixin';
import filterMixin from '@/mixins/filter';
import PageLayout from '@/components/autoscale/pageLayout.vue';
import SectionTop from '@/pages/webinars/components/sectionTop.vue';
import SectionCards from '@/pages/webinars/components/sectionCards.vue';
import SubscribePopup from './components/subscribePopup.vue';
import {
  SUBSCRIBE_POPUP_COOKIE,
  setSubscribePopupShowAfter,
  setSubscribePopupNeverShow,
  getSubscribePopupCookie,
} from '@/utils/subscribePopupCookie.js';

export default {
  name: 'EventsList',
  components: { PageLayout, SectionTop, SectionCards, SubscribePopup },
  mixins: [filterMixin, viewportMixin],
  layout: 'scaled',
  meta: {
    show: ['br', 'mx'],
  },
  middleware: ['eventDirections'],
  data() {
    return {
      filterNamespace: '',
      subscribePopupVisible: false,
      subscribeFormVisibleTimeout: null,
      cookieLifetimeSeconds: 7 * 24 * 60 * 60,
      showAfterTimeout: 10000,
    };
  },
  head() {
    const createHeadFunction = createHead.bind(this);
    return createHeadFunction();
  },
  computed: {
    isMx() {
      return this.$nuxt.$config.COUNTRY === 'mx';
    },
    shouldShowPopup() {
      if (!this.isMx) return false;

      // Если пользователь авторизован или есть что-то, что связывает его с cutsomer.io,
      // то не показываем форму, так как он уже подписан
      const user = this.$app.user;
      const cio_client_id = this.$route?.query?.cio_client_id;
      const _cio_id = this.$route?.query?._cio_id;
      const cioIdFromCookie =
        this.$app.getCookie('_cioid')?.replace(/cio_/g, '') || null;

      if (user || cio_client_id || _cio_id || cioIdFromCookie) return false;

      // Если форму когда-то отправили, то смотрим
      // есть ли кука, чтобы больше ее никогда не показывать
      const neverShow = getSubscribePopupCookie(
        SUBSCRIBE_POPUP_COOKIE.NEVER_SHOW,
      );
      if (neverShow) return false;

      // Если форму когда-то закрыли, то показываем ее,
      // когда истечет время, указанное в cookieLifetimeSeconds (смотрим куку)
      const showAfter = getSubscribePopupCookie(
        SUBSCRIBE_POPUP_COOKIE.SHOW_AFTER,
      );
      return !showAfter;
    },
  },
  mounted() {
    this.filterNamespace = 'eventList';

    // Если соблюдены условия shouldShowPopup,
    // то показываем форму через время, указанное в showAfterTimeout
    if (process.client) {
      if (this.shouldShowPopup) {
        this.subscribeFormVisibleTimeout = setTimeout(() => {
          this.subscribePopupVisible = true;
        }, this.showAfterTimeout);
      }
    }
  },
  destroyed() {
    clearTimeout(this.subscribeFormVisibleTimeout);
  },
  methods: {
    onFormSubmit() {
      window?.$meter?.event({
        name: 'formSubmit',
        label: 'subscribeFormOnWebiarList',
      });
    },
    closeSubscribePopup() {
      // Если форму закрыли, то ставим куку, чтобы возобновить
      // ее показ через время, указанное в cookieLifetimeSeconds
      this.subscribePopupVisible = false;
      setSubscribePopupShowAfter(this.cookieLifetimeSeconds);
    },
    onFormSuccess() {
      // Если форму отправили, то ставим куку, чтобы больше ее никогда не показывать
      this.subscribePopupVisible = false;
      setSubscribePopupNeverShow();
      window?.$meter?.event({
        name: 'formSuccess',
        label: 'subscribeFormOnWebiarList',
      });
    },
  },
};
